import React, { useContext } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import UserColumn from '../../../../commonComponents/lists/columns/UserColumn';
import List from '../../../../commonComponents/lists/List';
import ActionsColumn from '../leads/ActionsColumn';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

function RecommendationsList({ t, challengeId }) {
  const { loggedUser } = useContext(LoggedUserContext);

  const columns = [
    {
      field: 'name',
      title: t('challengeDetails_name'),
      sortable: false,
      template: row => renderToStaticMarkup(<UserColumn t={t} user={row} />),
    },
    {
      field: 'hardSkills',
      title: t('challengeDetails_hardSkills'),
      sortable: false,
    },
    {
      field: 'experience',
      title: t('challengeDetails_experience'),
      sortable: false,
      width: 100,
    },
    {
      field: 'age',
      title: t('challengeDetails_age'),
      sortable: false,
      width: 100,
    },
    {
      field: 'actions',
      sortable: false,
      title: '',
      width: 40,
      template: row =>
        renderToStaticMarkup(
          <ActionsColumn
            t={t}
            url={`/challenges/recommendations/${row._id}`}
          />,
        ),
    },
  ];

  const dataTransform = recommendation => ({
    ...recommendation,
    hardSkills: recommendation.hardSkills
      ? recommendation.hardSkills
          .reduce((acc, hs) => (hs.value ? [...acc, hs.name] : acc), [])
          .join(', ')
      : '- -',
    experience:
      recommendation.softSkills && recommendation.softSkills.experienceTime
        ? recommendation.softSkills.experienceTime
        : '- -',
    age:
      recommendation.birthday && recommendation.birthday > 0
        ? moment.utc().diff(recommendation.birthday, 'years')
        : '- -',
  });

  return (
    <List
      dataSourceURL="/challenges/recommendations"
      dataTransform={dataTransform}
      dataSourceParams={{
        game: challengeId,
        referencedBy: loggedUser ? loggedUser._id : undefined,
      }}
      columns={columns}
      id="leadsList"
      query={{}}
    />
  );
}

RecommendationsList.propTypes = {
  t: PropTypes.func.isRequired,
  challengeId: PropTypes.string.isRequired,
};

export default translate(RecommendationsList);
